import styled from 'styled-components';

import { blackSphera, whiteSphera, greenSp } from 'src/utilities/UIStyles/variables/Colors';

export const HomeContainer = styled.div``;

export const InvestUs = styled.section`
  background-color: #f8f8f9;
  padding: 5% 0;

  > div:nth-child(1) {
    > h2 {
      color: ${blackSphera};
      font-size: 3vw;
      text-align: center;
    }
  }

  > div:nth-child(2) {
    display: flex;
    width: 90%;
    margin: 2.5% auto 1% auto;

    > div {
      width: 33%;

      > figure {
        text-align: center;
        width: 150px;
        height: 150px;
        margin: 0 auto 2.5% auto;

        img {
          width: 100%;
          height: 100%;
        }
      }

      > h3 {
        color: ${blackSphera};
        text-align: center;
        font-size: 1.5vw;
      }

      > p {
        color: ${blackSphera};
        text-align: center;
        font-size: 1.3vw;
        width: 90%;
        margin: 2.5% auto 0 auto;
      }
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div:nth-child(1) {
      > h2 {
      }
    }

    > div:nth-child(2) {
      > div {
        > figure {
          width: 120px;
          height: 120px;
          margin: 0 auto 5% auto;

          img {
          }
        }

        > h3 {
        }

        > p {
        }
      }
    }
  }

  @media (max-width: 600px) {
    > div:nth-child(1) {
      > h2 {
        font-size: 6vw;
      }
    }

    > div:nth-child(2) {
      flex-direction: column;
      margin: 5% auto 1% auto;

      > div {
        width: 100%;

        > figure {
          width: 110px;
          height: 110px;
          margin: 5% auto 2.5% auto;

          img {
          }
        }

        > h3 {
          font-size: 4.5vw;
        }

        > p {
          font-size: 4vw;
          margin: 2.5% auto 2.5% auto;
        }
      }
    }
  }
`;

export const InvestFinSphera = styled.section`
  > div:nth-child(1) {
    > h2 {
      color: ${blackSphera};
      font-size: 3vw;
      text-align: center;
      width: 60%;
      margin: 2.5% auto 5% auto;

      > span {
        color: ${greenSp};
      }
    }
  }

  > div:nth-child(2) {
    display: flex;
    width: 90%;
    margin: 5% auto;

    > div {
      width: 25%;

      > figure {
        text-align: center;
        width: 150px;
        height: 150px;
        margin: auto;
      }

      > h3 {
        color: ${blackSphera};
        text-align: center;
        font-size: 1.3vw;
      }

      > p {
        color: ${blackSphera};
        text-align: center;
        font-size: 1.1vw;
        width: 75%;
        margin: 2.5% auto 0 auto;
      }
    }
  }

  > div:nth-child(3) {
    display: flex;
    justify-content: center;
    align-items: center;

    > a {
      display: block;
      color: ${whiteSphera};
      font-weight: bold;
      font-size: 1.5vw;
      text-decoration: none;
      text-align: center;
      line-height: 50px;
      width: 350px;
      height: 50px;
      border-radius: 5px;
      background-color: ${blackSphera};
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div:nth-child(1) {
      > h2 {
        margin: 5% auto;

        > span {
        }
      }
    }

    > div:nth-child(2) {
      > div {
        > figure {
          width: 100px;
          height: 100px;
          margin: 10% auto;

          img {
          }
        }

        > h3 {
        }

        > p {
          margin: 5% auto 0 auto;
        }
      }
    }

    > div:nth-child(3) {
      > a {
      }
    }
  }

  @media (max-width: 600px) {
    > div:nth-child(1) {
      > h2 {
        font-size: 6vw;
        width: 80%;
        margin: 10% auto;

        > span {
        }
      }
    }

    > div:nth-child(2) {
      flex-direction: column;

      > div {
        width: 100%;

        > figure {
          margin: 0 auto;
        }

        > h3 {
          text-align: center;
          font-size: 4vw;
        }

        > p {
          font-size: 4vw;
          margin: 1% auto 5% auto;
        }
      }
    }

    > div:nth-child(3) {
      > a {
        font-size: 4vw;
        width: 90%;
      }
    }
  }
`;

export const Transformation = styled.section`
  padding-bottom: 5%;

  > h2 {
    color: ${blackSphera};
    font-size: 3vw;
    text-align: center;
    margin: 5% auto 2.5% auto;

    > span {
      color: ${greenSp};
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > h2 {
      > span {
      }
    }
  }

  @media (max-width: 600px) {
    > h2 {
      font-size: 5vw;
      width: 90%;
      margin: 15% auto 5% auto;

      > span {
      }
    }
  }
`;

export const CardContainer = styled.div`
  display: flex;
  justify-content: space-around;
  width: 95%;
  margin: auto;

  @media (min-width: 600px) and (max-width: 1024px) {
    width: 80%;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    width: 90%;
  }
`;

export const Card = styled.div`
  padding: 4% 5%;
  width: 45%;
  -webkit-box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);
  box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);

  > div:nth-child(1) {
    display: flex;
    justify-content: space-between;

    > div {
      margin-bottom: 10%;

      > h3 {
        color: ${blackSphera};
        font-size: 1.5vw;
      }

      > p {
        color: ${blackSphera};
        font-size: 1.2vw;
      }

      > figure {
        width: 50px;
        height: 45px;
        margin-top: 20%;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    > figure {
      width: 120px;
      height: 120px;

      > img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
  }

  > div:nth-child(2) {
    > p {
      font-size: 1.1vw;
      color: ${blackSphera};
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div:nth-child(1) {
      > div {
        > h3 {
        }

        > p {
        }

        > figure {
          img {
          }
        }
      }

      > figure {
        > img {
        }
      }
    }

    > div:nth-child(2) {
      > p {
      }
    }
  }

  @media (max-width: 600px) {
    width: 100%;
    margin-bottom: 10%;

    > div:nth-child(1) {
      > div {
        > h3 {
          font-size: 4.5vw;
        }

        > p {
          font-size: 4.2vw;
        }

        > figure {
          width: 40px;
          height: 35px;

          img {
          }
        }
      }

      > figure {
        width: 140px;
        height: 140px;

        > img {
        }
      }
    }

    > div:nth-child(2) {
      > p {
        font-size: 4.1vw;
      }
    }
  }
`;

export const CarouselControllers = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 12%;
  margin: 2.5% auto 0 auto;

  > figure:nth-child(1) {
    width: 25px;
    height: 35px;
    cursor: pointer;
    transition: all 0.5s;

    &:hover {
      transform: scale(1.1);
    }

    img {
      width: 100%;
      height: 100%;
      transform: rotate(180deg);
    }
  }

  > p:nth-child(2) {
    color: ${blackSphera};
    font-size: 1.3vw;
  }

  > figure:nth-child(3) {
    width: 25px;
    height: 35px;
    cursor: pointer;
    transition: all 0.5s;

    &:hover {
      transform: scale(1.1);
    }

    > img {
      width: 100%;
      height: 100%;
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > figure:nth-child(1) {
      &:hover {
      }

      img {
      }
    }

    > p:nth-child(2) {
    }

    > figure:nth-child(3) {
      &:hover {
      }

      > img {
      }
    }
  }

  @media (max-width: 600px) {
    width: 40%;

    > figure:nth-child(1) {
      &:hover {
      }

      img {
      }
    }

    > p:nth-child(2) {
      font-size: 4.3vw;
    }

    > figure:nth-child(3) {
      &:hover {
      }

      > img {
      }
    }
  }
`;

export const OurServices = styled.section`
  display: flex;

  > div:nth-child(1) {
    width: 50%;
    background-color: #e7fd4f;
    padding: 5%;

    > h2 {
      color: ${blackSphera};
      font-size: 3vw;
      margin-bottom: 15%;
    }

    > div {
      display: flex;
      width: 90%;

      > a:nth-child(1) {
        display: block;
        color: ${whiteSphera};
        font-size: 1.5vw;
        text-decoration: none;
        text-align: center;
        line-height: 40px;
        width: 240px;
        height: 40px;
        margin-right: 10%;
        border-radius: 5px;
        background-color: ${blackSphera};
      }

      > a:nth-child(2) {
        display: block;
        color: ${blackSphera};
        font-size: 1.5vw;
        text-decoration: none;
        text-align: center;
        line-height: 40px;
        width: 240px;
        height: 40px;
        border: 1px solid ${blackSphera};
        border-radius: 5px;
      }
    }
  }

  > figure {
    width: 50%;

    > img {
      width: 100%;
      height: 100%;
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    height: 300px;

    > div:nth-child(1) {
      > h2 {
      }

      > div {
        a:nth-child(1) {
        }

        > a:nth-child(2) {
        }
      }
    }

    > figure {
      img {
      }
    }
  }

  @media (max-width: 600px) {
    flex-direction: column;
    height: auto;

    > div:nth-child(1) {
      width: 100%;
      padding-bottom: 10%;

      > h2 {
        font-size: 6vw;
        margin-top: 5%;
        margin-bottom: 10%;
      }

      > div {
        > a:nth-child(1) {
          font-size: 4vw;
          line-height: 50px;
          height: 50px;
        }

        > a:nth-child(2) {
          font-size: 4vw;
          line-height: 50px;
          height: 50px;
        }
      }
    }

    > figure {
      width: 100%;

      > img {
      }
    }
  }
`;
